(function() { window.GUID_3e76b748_85de_4851_81ab_44e6d87442c2 = { getGuid: function() { return "3e76b748-85de-4851-81ab-44e6d87442c2"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Stepper extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnBindEvents() {
            }
            OnDispose() {
            }
        }
        Controls.Stepper = Stepper;
        (function (Stepper) {
            let Button;
            (function (Button) {
                class Events {
                }
                Button.Events = Events;
                class EventNames {
                }
                Button.EventNames = EventNames;
            })(Button = Stepper.Button || (Stepper.Button = {}));
        })(Stepper = Controls.Stepper || (Controls.Stepper = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=stepper.js.map
